module.exports = {
  fastDelivery: 'ASAP',
  appointmentDelivery: 'Appointment Delivery',
  fastOrder: 'Speed 30min',
  // 待接单提示
  waitOrder: 'Please Accept Order Before {args1} ',
  // 开始备餐
  preOrder: 'Please Prepair Before {args1} ',
  // 完成备餐
  preMealOrder: 'Please Complete  Before {args1}',
  // 备餐完成
  completeMealOrder: 'Ready Prepaired  at {args1}',
  // 处理取消申请
  processCancelOrder: 'Please Process Cancel  Before {args1}',
  // 完成订单
  completeOrder: 'Ready Complete Order at {args1}',
  // 取消订单
  cancelOrder: 'The order has been cancelled at {args1}',
  // 订单号
  orderNo: 'OrderNo',
  // 下单时间
  orderTime: 'OrderTime',
  orderDate: 'Order Date',
  showAll: 'View All',
  // 共{args}种商品
  allProduct: 'Total {args1} Items',
  // 第{args1}次下单
  orderTimes: 'Place an order {args1} times',
  // 配送费
  deliveryFee: 'Delivery Fee',
  // 增值税
  vat: 'VAT',
  platformDiscount: 'Platform Discount',
  platformFull: 'Platform Full Reduction',
  platformCoupons: 'Platform Coupons',
  storeFull: 'Store Full Reduction',
  storeFirstOrder: 'Store First Order',
  storeShipping: 'Shipping Coupons',
  storeCoupons: 'Store Coupons',
  custPay: 'Customer Payment',
  estimatedIncome: 'Estimated Income',
  consigneeName: 'Receiver',
  recipientAddress: 'recipient address',
  orderStatus: 'Order Status',
  deliveryStatus: 'Delivery Status',
  remark: 'Remarks',
  noRemark: 'No remarks',
  productDetails: 'Product Details',
  picture: 'Picture',
  name: 'Name',
  specification: 'Specification ',
  attributes: 'Attributes',
  quantity: 'Quantity',
  total: 'Total',
  price: 'Price',
  totalAmount: 'Total Amount',
  totalNum: 'Total Quantity',
  writeReason: 'Please enter the reason for the {args1}',
  linkTel: 'Contact Number',
  receiverPhone: 'Customer Phone',
  riderPhone: 'Rider Phone',
  stationPhone: 'Station Phone',
  automaticOrder: 'Automatic Order',
  mark: 'MarkCode',
  acceptOrder: 'Accept Order',
  rejectOrder: 'Reject Order',
  reasonNull: 'Reason cannot be empty!',
  startTime: 'Start Time',
  asOfTime: 'End Time',
  prepareMeal: 'Start Preparing',
  prepareFinish: 'Prepared',
  agreeRefund: 'Accept Refund',
  refuseRefund: 'Reject Refund',
  agreeCancel: 'Accept Cancel',
  rejectCancel: 'Reject Cancel',
  refundDesc: 'Reject Description',
  OriginalPrice: 'Total Original Price',
  applying: 'Cancel application',
  discountPrice: ' Total Price After Discount',
  refunding: 'Refund application',
  cancelled: 'Cancelled',
  appointmentPass: 'Appointment order expires',
  promotionCode: 'Promotion Code',
  showDetail: 'Item Detail',
  productGift: 'Free Item',
  cancelReason: 'Cancel Reason',
  selectReason: 'Please select the reason？',
  storeRating: 'Store Rating',
  goodEvaluateRate: 'Good Evaluate Rate',
  evaluate: 'Evaluate',
  replyOrNot: 'Reply or Not',
  replied: 'Replied',
  unReplied: 'Not Reply',
  custPhoto: 'Customer Photo',
  custNick: 'Customer Nickname',
  evaluateTime: 'Evaluate Time',
  evaluateScore: 'Score',
  evaluateContent: 'Evaluate Content',
  storeReply: 'Store Reply',
  replyTime: 'Reply Time',
  reply: 'Reply',
  custEvaluate: 'Customer Evaluate ',
  hasContent: 'Content',
  haveContent: 'Have Content',
  noContent: 'No Content',
  photo: 'Photo',
  requiredReply: 'Remark(Required,500 Character)',
  allPicture: 'Total {num} pictures',
  largeOrderTips: 'This order involves a large amount, please handle it with caution',
  feedbackTitle:'Order Feedback',
  contactInfo: 'Contact Information',
  feedbackReason: 'Feedback Reason',
  detailDesc: 'Feedback Detail',
  descPlaceholder: 'Describe your issue/requirements',
  pic: 'Feedback Pictures',
  merchant :'Merchant',
  feedbackDetailTitle: 'Order Feedback Detail',
  feedbackNo: 'Feedback No.',
  feedbackRole: 'Feedback Role',
  feedbackTime: 'Feedback Time',
  handleLog: 'Feedback History',
  pending: 'Pending',
  processing: 'Processing',
  Solved: 'Solved',
  Rejected: 'Rejected',
  time: 'Time',
  type: 'Type',
  operatorName : 'Operator',
  logCnt: 'Processing Content',
  logStatus : 'Processing Status',
  checkFeedback: 'View order feedback',
  issueOrder: 'Have issues with order?',
  try: 'Try',
  orderFeedback: 'order feedback',
  submitFeedback:'Feedback Submitted',
  acceptFeedback:'Accept',
  handleFeedback:"Processing",
  completeFeedback:"Processed",
  solvedFeedback:"Processed-Solved",
  vatRate: 'VAT rate',
  originalTotalPrice: 'Original Total Price',
  totalPriceAfterDiscount: 'Total Price After Discount',
  pendingSettleTip: 'Unsettled (expected to be settled by {time})',
  doneSettleTip: 'Settled ({time})',
  userPicked: 'Meal picked up',
  selfPickUp: 'Pick-up',
  userPickedOrderTipTitle: 'Kind reminder',
  userPickedOrderTip: 'If the user has received the product, please click OK to complete the order.',
}
